import { set, keyBy } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { searchPosItems } from '../../sagas/routines';
import { clearPosSearchItems } from '../../actions/searchItems';
import getItemAvailabilityUniqId from '../../../../helpers/getItemAvailabilityUniqId';

const initialState = {
  byUniqId: {},
  fetching: false,
  fetched: false,
  fetchingError: null
};

export const searchPosItemsHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('byUniqId', keyBy(getItemAvailabilityUniqId, response.items), state),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const clearPosSearchItemsHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    byUniqId: {},
    fetched: false
  })
});

export default createReducer(initialState, {
  ...searchPosItemsHandler(searchPosItems),
  ...clearPosSearchItemsHandler(clearPosSearchItems)
});
